var map = {
	"./alert-critical-1.mp3": "./src/assets/sounds/alert-critical-1.mp3",
	"./alert-info-1.mp3": "./src/assets/sounds/alert-info-1.mp3",
	"./alert-info-2.mp3": "./src/assets/sounds/alert-info-2.mp3",
	"./alert-info-3.mp3": "./src/assets/sounds/alert-info-3.mp3",
	"./alert-info-4.mp3": "./src/assets/sounds/alert-info-4.mp3",
	"./alert-info-5.mp3": "./src/assets/sounds/alert-info-5.mp3",
	"./beyond-doubt-2.mp3": "./src/assets/sounds/beyond-doubt-2.mp3",
	"./filling-your-inbox.mp3": "./src/assets/sounds/filling-your-inbox.mp3",
	"./long-expected.mp3": "./src/assets/sounds/long-expected.mp3",
	"./oh-finally.mp3": "./src/assets/sounds/oh-finally.mp3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/sounds sync recursive ^\\.\\/.*\\.mp3$";